<style type="text/css" media="screen">

.status-confirmation-pending,
.status-withdrawn{
	color: #2D9CDB;
}
.status-confirmed,
.status-dropped-at-warehouse,
.status-out-for-delivery,
.status-delivered{
	color: #1DC895;
}
.status-on-hold,
.status-return,
.status-partial-return
{
	color: #F2994A;
}
.status-cancelled{
	color: #b71c1c;
}
</style>

<template>
	<div>
		<v-row class="mb-8 " style="margin-top:-15px">
			<v-col md="12" class="mt-2" px="py-0">
				<div class="filter-btn status-text-filter px-4 py-1 ma-2 cursor-pointer border-rounded"
				:class="selected_status==item.status?'elevation-1':''" 
				v-for="(item,i) in status_count_list" :key="i"
				@click="selectStatus(item)">
				{{item.status}}
				<span v-if="i!=0" >
					-
				</span>

				<span class="fs-18 fw-bold" :class="getClass(item.status)">
					{{item.count}}
				</span>
			</div>
		</v-col>
	</v-row>
</div>
</template>

<script type="text/javascript">
export default{
	props:['filter_data'],
	data(){
		return{
			selected_status:"All",
			status_count_list:[
			{ 
				status: "All",
				status_filter:null,
				count:null,
			},
			{ 
				status: "Pick up",
				status_filter:['Confirmation Pending','Confirmed','Picked up'],
				count:"0",
			},
			{ 
				status: "Warehouse",
				status_filter:['On Hold','Dropped at Warehouse','Dropped at Warehouse return','Return','Partial Return'],
				count:"0",
			},
			{ 
				status: "Delivery",
				status_filter:['Out for Delivery','Delivered'],
				count:"0",
			},
			{ 
				status: "Cancelled",
				status_filter:['Cancelled'],
				count:"0",
			},
			{ 
				status: "Withdrawn",
				status_filter:['Withdrawn'],
				count:"0",
			},
			
			]
		}

	},
	created(){
		this.getOverviewData()
	},
	methods:{
		selectStatus(item){
			this.selected_status=item.status;
			this.$emit("update_filter", item.status_filter);
		},
		getClass(shipment_status){
			let cl =shipment_status.replace(" ", '-');
			cl =cl.replace(" ", '-');
			cl=cl.toLowerCase()
			cl="status-"+cl
			return cl
		},
		/* Fetching tha  cpunting data */ 
		getOverviewData(){
			this.$store.dispatch('setPageLoader', true)
			const self=this
			let params={};

			const successHandler = (response) => {
				console.log(response)
				if (response.data.success){
					let data= response.data
					self.status_count_list[1].count=(data.new_order_count+data.confirmed_count+data.picked_up_count)
					self.status_count_list[2].count=(data.at_warehouse+data.on_hold_count+data.returned_count+data.partial_returned_count+data.dropped_at_warehouse_return_count)
					self.status_count_list[3].count=(data.out_for_delivery_count+data.delivered_count)
					self.status_count_list[4].count=response.data.cancelled_count
					self.status_count_list[5].count=response.data.withdrawn_count

				}
			};
			const finallyHandler = () => {
				this.$store.dispatch('setPageLoader', false)

			};
			self.request_GET( self,self.$urls.WAREHOUSE_DASHBOARD,params,successHandler,null,null,finallyHandler)
		},

	}
}
</script>